__turbopack_context__.v({
  "container-page": "hEhvoq_container-page",
  "form-greeting": "hEhvoq_form-greeting",
  "image-content": "hEhvoq_image-content",
});
